var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHourglass = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 61,
    viewBox: "0 0 58 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7368 2.27021C31.5786 -0.0900711 26.4213 -0.09007 22.2631 2.27021L7.31497 10.755C3.25655 13.0587 0.764648 17.2628 0.764648 21.8063L0.764648 39.1937C0.764648 43.7372 3.25655 47.9413 7.31497 50.245L22.2631 58.7298C26.4213 61.0901 31.5786 61.0901 35.7368 58.7298L50.6849 50.245C54.7433 47.9413 57.2352 43.7372 57.2352 39.1937L57.2352 21.8063C57.2352 17.2628 54.7433 13.0587 50.6849 10.755L35.7368 2.27021Z",
    fill: "#0E2659"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7368 2.27021C31.5786 -0.0900711 26.4213 -0.09007 22.2631 2.27021L7.31497 10.755C3.25655 13.0587 0.764648 17.2628 0.764648 21.8063L0.764648 39.1937C0.764648 43.7372 3.25655 47.9413 7.31497 50.245L22.2631 58.7298C26.4213 61.0901 31.5786 61.0901 35.7368 58.7298L50.6849 50.245C54.7433 47.9413 57.2352 43.7372 57.2352 39.1937L57.2352 21.8063C57.2352 17.2628 54.7433 13.0587 50.6849 10.755L35.7368 2.27021Z",
    fill: "url(#paint0_radial_11667_371969)",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0007 13.5179L34.0526 5.03304C30.9339 3.26282 27.0659 3.26282 23.9473 5.03304L8.99919 13.5179C5.95537 15.2456 4.08645 18.3987 4.08645 21.8063L4.08645 39.1937C4.08645 42.6013 5.95537 45.7544 8.99919 47.4821L23.9473 55.967C27.0659 57.7372 30.9339 57.7372 34.0526 55.967L49.0007 47.4821C52.0445 45.7544 53.9134 42.6013 53.9134 39.1937L53.9134 21.8063C53.9134 18.3987 52.0445 15.2456 49.0007 13.5179ZM35.7368 2.27021C31.5786 -0.0900713 26.4213 -0.09007 22.2631 2.27021L7.31497 10.755C3.25655 13.0587 0.764648 17.2628 0.764648 21.8063L0.764648 39.1937C0.764648 43.7372 3.25655 47.9413 7.31497 50.245L22.2631 58.7298C26.4213 61.0901 31.5786 61.0901 35.7368 58.7298L50.6849 50.245C54.7433 47.9413 57.2352 43.7372 57.2352 39.1937L57.2352 21.8063C57.2352 17.2628 54.7433 13.0587 50.6849 10.755L35.7368 2.27021Z",
    fill: "url(#paint1_linear_11667_371969)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8751 34.6248C23.1038 51.2804 31.441 42.1304 28.8829 36.6811C27.4342 33.5949 24.8752 33.1249 22.2496 33.125C19.6239 33.1252 17.7498 33.8747 15.8751 34.6248Z",
    fill: "#4987FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0515 30.5014C44.103 27.4499 44.3126 27.2403 44.3126 27.2403C44.7604 26.7925 44.7604 26.0634 44.3126 25.6155L33.7829 15.0859C33.3351 14.638 32.6059 14.638 32.1581 15.0859C32.1581 15.0859 31.9112 15.3327 28.8769 18.3671C25.8426 21.4014 28.0846 26.5772 26.5115 28.1503C24.9383 29.7235 19.7596 27.4872 16.731 30.5158L13.4843 33.7625C13.0365 34.2104 13.0365 34.9395 13.4843 35.3873L14.2192 36.1222L23.348 45.251L24.014 45.917C24.4618 46.3648 25.191 46.3648 25.6388 45.917L28.8855 42.6703C31.8969 39.6589 29.5974 34.7357 31.3457 32.9846C33.0968 31.2335 38.0028 33.5501 41.0515 30.5014ZM29.7209 31.3598C28.2913 32.7894 28.2913 34.8276 28.2913 36.6275C28.2913 38.6714 28.2224 40.0809 27.2578 41.0455L25.2283 43.075L16.3205 34.1673L18.3501 32.1377C19.4295 31.0583 21.2639 31.0698 23.0379 31.0842C24.8838 31.0985 26.7928 31.11 28.1305 29.7723C29.4683 28.4345 29.4539 26.5284 29.4396 24.6826C29.4223 22.5037 29.4884 20.9995 30.496 19.989L32.5399 17.9451L41.4476 26.8528L39.4238 28.8766C38.4363 29.8641 37.0153 29.9388 34.9656 29.9359C33.1743 29.9359 31.1476 29.933 29.718 31.3598H29.7209Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11667_371969",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.9999 30.5) rotate(90) scale(30 28.2353)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4987FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4987FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11667_371969",
    x1: 28.9999,
    y1: 0.5,
    x2: 28.9999,
    y2: 60.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005CE8"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHourglass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hourglass.e062ab58038f17972a71845727e1f80b.svg";